import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Modal from '../../components/Modal/Modal';
import FormRequestCall from '../../components/Form/FormRequestCall';

const RequestCallModal = NiceModal.create(() => {
  const modal = useModal();
  return (
    <Modal
      title="Call back from a specialist"
      onClose={() => {
        modal.remove();
      }}
    >
      <p>Please complete the form below and we'll call you back shortly.</p>
      <FormRequestCall />
    </Modal>
  );
});

export default RequestCallModal;
